<script>
	import { DialogNew } from '@shopboxai/sb-portal-components';
	import PageTypeSelect from '../../PageTypeSelect.svelte';
	import { id, continueTour, endTour } from '../../../utils/utils.js';

	export let data = {
		name: '',
		id: id(),
		page_type: 'homepage',
		mobile: { items: [] },
		desktop: { items: [] }
	};
</script>

<DialogNew {data} on:submit on:close={endTour}>
	<div slot="header">Add name for the new grid</div>
	<div slot="content" class="dialog-form-wrapper">
		<input type="hidden" name="id" bind:value={data.id} />
		<label for="title">Grid Name</label>
		<input id="title" type="text" bind:value={data.name} required />
		<PageTypeSelect bind:value={data.page_type} />
	</div>
	<button slot="toggle" class="primary tour-step-1" on:click|preventDefault={() => continueTour(1)}
		>Start From Scratch</button
	>
</DialogNew>

<style></style>
